/**
 * Marine Tackle NZ — store configuration.
 *
 * This demo is a single-store storefront: the whole app is scoped to Marine
 * Tackle's real iSQROLL seller account on the live backend (isqroll-7f137).
 * Their account already holds 224 high-quality bulk-imported listings with
 * hosted images, so the shop runs on REAL live data via StorefrontPage.
 */
export const STORE = {
  /** Marine Tackle's real iSQROLL seller UID (live backend). */
  sellerId: 'ZSM4s2cthAQvDJMsgBtMxAfIydJ3',
  /** Their storeSlug on iSQROLL (used by the storefront router). */
  slug: 'marinetackle',
  name: 'Marine Tackle',
  legalName: 'Marine Tackle NZ',
  tagline: 'For all your fishing & chandlery needs',
  location: 'Whanganui, New Zealand',
  phone: '06 345 6958',
  email: 'office@marinetackle.co.nz',
  address: '16 Wilson Street, Whanganui',

  /** Brand palette (from the current marinetackle.co.nz site). */
  colors: {
    primary: '#2ba84a', // signature nautical green
    primaryDark: '#1f8039',
    primaryLight: '#3fca63',
    charcoal: '#252525', // body text
    footer: '#171717', // dark footer
  },

  /** Local brand assets (public/brand/). */
  assets: {
    logo: '/brand/2024-logo.jpg',
    logoSmall: '/brand/2024-logo-s.jpg',
    heroSlides: ['/brand/front-slide-1.jpg', '/brand/front-slide-2.jpg', '/brand/front-slide-3.jpg'],
    partners: [
      { name: 'Yamaha', logo: '/brand/yamaha_logo.jpg' },
      { name: 'Can-Am', logo: '/brand/canam-logo.jpg' },
      { name: 'BRP Marine', logo: '/brand/marine_logo.jpg' },
      { name: 'Can-Am Parts', logo: '/brand/canamparts-logo.png' },
    ],
  },
} as const
